import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getControlGroupFormConfig = () => {
  return {
    Title: {
      fieldId: 'Title',
      formLabel: t('controlGroups.fields.Title'),
      columnHeader: t('controlGroups.columns.title'),
    },
    Description: {
      fieldId: 'Description',
      formLabel: t('fields.Description'),
      columnHeader: t('controlGroups.columns.description'),
      displayType: { displayType: 'textarea' },
    },
    Owner: {
      fieldId: 'Owner',
      formLabel: t('controlGroups.fields.Owner'),
      columnHeader: t('controlGroups.columns.owner_username'),
    },
  } as const satisfies FormConfig;
};
